var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ac-card',{attrs:{"preload":"card-handler"},scopedSlots:_vm._u([{key:"section",fn:function(ref){
var sortedData = ref.sortedData;
return [_vm._v("\n        "+_vm._s(sortedData)+"\n    ")]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }